import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../atoms/Icon';

const NavItem = ({ 
  href, 
  icon, 
  children, 
  active = false, 
  onClick,
  className = '' 
}) => {
  const baseStyles = 'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium leading-normal transition-colors';
  const activeStyles = active 
    ? 'bg-primary/10 text-primary' 
    : 'text-text-light-primary dark:text-text-dark-primary hover:bg-primary/10 hover:text-primary';
  
  const classes = `${baseStyles} ${activeStyles} ${className}`;
  
  const content = (
    <>
      {icon && <Icon name={icon} size={20} />}
      <span>{children}</span>
    </>
  );
  
  if (href) {
    return (
      <Link to={href} className={classes}>
        {content}
      </Link>
    );
  }
  
  return (
    <button onClick={onClick} className={classes}>
      {content}
    </button>
  );
};

export default NavItem;

